// extracted by mini-css-extract-plugin
export default {"Blocks":"HowItWorks_Blocks__5I-+Z","Title":"HowItWorks_Title__6Tffv"};